module.exports = __webpack_public_path__ + "static/media/icon-magnifier-disabled.32ae0b7e.svg";